
import './App.css';
import React, { Component } from 'react';

function App() {
  return (
    <>
    <div className="js-replace-seo-section-container">
  <div
    id="content_banner_vertical_1"
    className="x-content-banner-vertical-component -bg-banner   "
  >
    <div className="container -content-wrapper ">
      <div className="-text-wrapper">
        <h2 className="-title">
          Fairbet คาสิโนออนไลน์เต็มรูปแบบ ตื่นตาตื่นใจไปกับทุกการเดิมพัน
        </h2>
        <p className="-sub-title">
          เดิมพันง่าย ฝากถอนไว Fairbet คาสิโนออนไลน์อันดับ #1 ของไทย
          ปรับไม้ได้ตลอดการเดิมพัน เล่นได้ทุกค่าย ไม่ต้องโยกเงิน ซัพพอท 24 ชม.
          เหนือกว่าทุกระดับ กับเว็บตรงไม่ผ่านเอเย่นต์ เล่นได้ทั้งคอม และมือถือ
        </p>
      </div>
      <div className="-banner-wrapper">
        <img
          alt="Fairbet Image"
          className="img-fluid -mobile-img lazyloaded"
          width={900}
          height={530}
          data-src="/build/web/igame-index-lobby-wm/img/wm-casino-gameplay-device.png?v=4"
          src="/build/web/igame-index-lobby-wm/img/wm-casino-gameplay-device.png?v=4"
        />
      </div>
    </div>
  </div>
  <div
    id="content_banner_vertical_2"
    className="x-content-banner-vertical-component -bg-banner   "
  >
    <div className="container -content-wrapper ">
      <div className="-text-wrapper">
        <h2 className="-title">
          Fairbet เว็บไซต์พนันออนไลน์ยอดนิยม บริการคาสิโนที่ดีที่สุด
        </h2>
        <div>
          {" "}
          <ul className="navbar flex-column align-items-start text-left">
            {" "}
            <li className="nav-item">
              {" "}
              <strong className="text-primary">
                Fairbet คาสิโน สำหรับทุกคน
              </strong>{" "}
              <p>โต๊ะให้เลือกมากที่สุด ภาพชัด เสถียร ไร้ปัญหาจุกจิก</p>{" "}
            </li>{" "}
            <li className="nav-item">
              {" "}
              <strong className="text-primary">
                เล่น Fairbet ต้องเล่นเว็บตรง
              </strong>{" "}
              <p>
                เราคือเว็บตรง #1 เจ้าเดียวในเอเชีย ผู้นำระบบออโต้
                ฝ่ายบริการมืออาชีพ
              </p>{" "}
            </li>{" "}
            <li className="nav-item">
              {" "}
              <strong className="text-primary">
                wmbet.ai, The place for bet
              </strong>{" "}
              <p>เว็บดียอดผู้เล่นสูง เพลิดเพลิน มั่นใจ กับแหล่งเดิมพันของคุณ</p>{" "}
            </li>{" "}
            <li className="nav-item">
              {" "}
              <strong className="text-primary">
                สนุก และ คว้าชัยชนะได้ทุกที่ทุกเวลา
              </strong>{" "}
              <p>
                แพลตฟอร์ม คาสิโน สปอร์ต และ เกมพนัน
                ให้คุณสามารถเลือกได้ในแบบที่คุณต้องการ
              </p>{" "}
            </li>{" "}
            <li className="nav-item">
              {" "}
              <strong className="text-primary">
                ความลงตัวของเทคโนโลยี และ งานบริการ
              </strong>{" "}
              <p>
                ด้วยฝ่ายบริการลูกค้าคุณภาพ 24 ชั่วโมง และระบบฝากถอนแสนง่าย
                อัจฉริยะ ที่ใครๆ ก็ว๊าว
              </p>{" "}
            </li>{" "}
          </ul>{" "}
        </div>
      </div>
    </div>
  </div>
  <div className="x-list-of-contents-container">
    <div className="container">
      <div
        className="-accordion-list-wrapper accordion"
        id="listOfContentsAccordion"
      >
        <article className="-accordion-list-item-wrapper">
          <p
            className="-btn -show -sm"
            data-toggle="collapse"
            data-target="#listOfContents"
          >
            {" "}
            <span className="-title">สารบัญ</span>
            <i className="fas fa-plus" />
            <i className="fas fa-minus" />
          </p>
          <div
            id="listOfContents"
            className="collapse show -content-collapse js-q-and-a-article-content"
            aria-labelledby="headingOne"
            data-parent="#listOfContentsAccordion"
          >
            <a href="#" className="-description">
              Fairbet คาสิโนออนไลน์ บาคาร่า ไฮโล เสือมังกร เว็บตรง WMBET
            </a>
            <a href="#" className="-description">
              Fairbet คาสิโนออนไลน์เต็มรูปแบบ ตื่นตาตื่นใจไปกับทุกการเดิมพัน
            </a>
            <a href="#" className="-description">
              Fairbet เว็บไซต์พนันออนไลน์ยอดนิยม บริการคาสิโนที่ดีที่สุด
            </a>
            <a href="#sectionSureSafe" className="-description">
              คาสิโนออนไลน์ใหม่ ที่มั่นคงปลอดภัย
            </a>
            <a href="#sectionBestCasino" className="-description">
              Livecasino คาสิโนสดทำเงิน ให้สมาชิกได้เป็นอย่างดี
            </a>
            <ul className="-list">
              <li className="-list-item">
                <a href="#sectionBestCasino" className="-link">
                  Livecasino ระบบคาสิโนสดที่ดีที่สุด
                </a>
              </li>
              <li className="-list-item">
                <a href="#sectionEasyUse" className="-link">
                  ช่องทางในการเข้าถึง Fairbet คาสิโน ได้อย่างสะดวก
                  และรวดเร็วมากที่สุด
                </a>
              </li>
              <li className="-list-item">
                <a href="#" className="-link">
                  คำถามที่พบบ่อย Fairbet
                </a>
              </li>
            </ul>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div className="x-content-banner-horizontal-component -not-merge  " id="">
    <div className="container">
      <div className="-banner-container -banner-left">
        <div className="-text-wrapper -text-wrapper-right">
          <div className="-text-wrapper-inner">
            <h3 className="-text-title">คาสิโนออนไลน์ใหม่ ที่มั่นคงปลอดภัย</h3>
            <div>
              {" "}
              <ul className="nav text-left">
                {" "}
                <li className="nav-item mt-2">
                  - เห็นทุกมุมมองของการเดิมพัน
                  ดูแลความปลอดภัยของผู้ใช้บริการด้วยโปรแกรมเมอร์มืออาชีพ
                  มีระบบตรวจสอบดูแลพร้อมที่จะทำให้ผู้ใช้บริการมั่นใจถึงความปลอดภัย
                </li>{" "}
                <li className="nav-item mt-2">
                  - ตรวจสอบผลการเดิมพันอย่างตรงไปตรงมา
                  ทุกระบบการทำธุรกรรมทางการเงินอัปเกรดให้รวดเร็วยิ่งขึ้น ฝาก-ถอน
                  ด้วยเวลาเพียง 4-5 วินาที
                  คุณก็สามารถรับผลกำไรที่เป็นของคุณได้เลยทันที
                </li>{" "}
                <li className="nav-item mt-2">
                  -
                  เรากลายเป็นส่วนหนึ่งของผู้ที่ต้องการเพิ่มรายได้หลักพันบาทต่อวันไปแล้วในทุกวันนี้
                  ได้เข้ามาตอบโจทย์ปัญหานี้เป็นอย่างดี เป็นเกมส์ออนไลน์
                  ที่สามารถทำเงินได้จริง
                </li>{" "}
                <li className="nav-item mt-2">
                  - ในการเดิมพันกับเรา สมาชิกทั้งหลายจะได้รับความปลอดภัย 100%
                  ด้วยระบบเก็บข้อมูลของลูกค้า ที่ออกแบบมาเป็นอย่างดี
                  นอกจากนี้เรื่องการทำธุรกรรมทางการเงินยังได้รับมาตรฐานสากลอีกด้วย
                </li>{" "}
              </ul>{" "}
            </div>
          </div>
        </div>
        <div className="-img-wrapper">
          <img
            alt="Fairbet Image"
            className="img-fluid mx-auto lazyloaded"
            width={500}
            height={500}
            data-src="/build/web/igame-index-lobby-wm/img/wm-casino-info-banner-1.png?v=4"
            src="/build/web/igame-index-lobby-wm/img/wm-casino-info-banner-1.png?v=4"
          />
        </div>
      </div>
    </div>
  </div>
  <div className="x-content-banner-horizontal-component -not-merge  " id="">
    <div className="container">
      <div className="-banner-container -banner-left">
        <div className="-text-wrapper -text-wrapper-right">
          <div className="-text-wrapper-inner">
            <div className="mt-4">
              {" "}
              <h3 className="-title text-primary f-6">
                Livecasino คาสิโนสดทำเงิน ให้สมาชิกได้เป็นอย่างดี
              </h3>{" "}
              <p className="-sub-title">
                Livecasino เกมคาสิโน
                ที่สามารถทำเงินได้จริงการันตีจากสมาชิกที่เข้ามาใช้บริการจริง
                รับรองถึงความสนุกสนานที่จะทำให้ท่านนั้นติดใจ กับเกมสร้างรายได้
                ที่แตกต่างและเหนือกว่าเว็บใดที่ท่านเคยเจอ และเล่นง่าย ไม่ซับซ้อน
                และยุ่งยาก แต่ปัจจุบันได้มีการพัฒนารูปแบบสมัยใหม่
                มีเกมให้เลือกเล่นมากมาย และสามารถเดิมพันผ่านมือถือ
                ไม่ว่าจะอยู่ที่ไหน เพียงแค่มีอินเทอร์เน็ต
                ก็สามารถทำเงินได้ตามความต้องการ
              </p>{" "}
            </div>{" "}
            <div className="mt-4">
              {" "}
              <h3 className="-title text-primary f-5">
                Livecasino ระบบคาสิโนสดที่ดีที่สุด
              </h3>{" "}
              <p className="-sub-title">
                Livecasino คาสิโนสดครบวงจร บริการเต็มรูปแบบ เกมไพ่ยอดฮิต
                บาคาร่าออนไลน์ สล็อต เสือมังกร รูเล็ต
                ให้ผู้เล่นทุกท่านได้เพลิดเพลินแบบไร้ขีดจำกัดกับระบบถ่ายทอดสดที่ดีที่สุด
                จากต่างประเทศ การันตี ภาพสวยคมชัด และเสียงที่สมจริง
                มีสาวสวยดีลเลอร์คอยแจกไพ่
                ทำให้ผู้เล่นได้สัมผัสราวกับได้เข้าไปเดิมพันจริงๆ พร้อมระบบฝากถอน
                รวดเร็วทันใจ ทำรายได้ด้วยตนเองผ่านหน้าเว็บไซต์
              </p>{" "}
            </div>
          </div>
        </div>
        <div className="-img-wrapper">
          <img
            alt="Fairbet Image"
            className="img-fluid lazyload mx-auto"
            width={500}
            height={500}
            data-src="/build/web/igame-index-lobby-wm/img/wm-casino-info-banner-2.png?v=4"
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    id="sectionEasyUse"
    className="x-content-banner-vertical-component -bg-banner   "
  >
    <div className="container -content-wrapper -banner-top">
      <div className="-text-wrapper">
        <h2 className="-title">
          ช่องทางในการเข้าถึง WMคาสิโน ได้อย่างสะดวก และรวดเร็วมากที่สุด
        </h2>
        <div>
          {" "}
          <p className="-sub-title">
            สำหรับช่องทางการให้บริการของ WMคาสิโน
            ที่เข้าเล่นได้อย่างสะดวกสบายมากยิ่งขึ้นด้วยการพัฒนาช่องทางหลัก
            ให้มีความเสถียรจึงช่วยทำให้ผู้เล่นได้เข้าถึงเว็บไซต์
            ได้อย่างง่ายดายโดยแบ่งออกเป็นการเข้าถึงผ่านทางมือถือ ได้ทั้งระบบ IOS
            , ANDROID และคอมพิวเตอร์ โดยวิธีการในการใช้งานของทั้ง 3
            ระบบนี้มีดังนี้
          </p>{" "}
          <ul className="nav text-left">
            {" "}
            <li className="nav-item mt-2">
              - วิธีการเข้าใช้งาน ผ่านทางมือถือระบบ IOS
              สามารถใช้งานได้โดยที่ไม่ต้องทำการติดตั้งใด ๆ โดยการเข้าผ่านทางแอพ
              SAFARI หรือ GOOGLE
              จะช่วยทำให้ผู้เล่นเข้าถึงได้อย่างสะดวกมากยิ่งขึ้นโดยที่ท่านไม่จำเป็นจะต้องตั้งค่าใด
              ๆ บนโทรศัพท์มือถือ
              ไม่มีข้อจำกัดของโทรศัพท์อีกด้วยเพียงแค่สามารถเชื่อมต่อเข้ากับอินเทอร์เน็ตได้เท่านั้น
              ก็สามารถใช้งานได้เลย
            </li>{" "}
            <li className="nav-item mt-2">
              - การใช้งานผ่านทางโทรศัพท์มือถือระบบ ANDROID
              สามารถวางเดิมพันได้ในทุกรุ่นของโทรศัพท์มือถือ
              สามารถวางเดิมพันได้โดยที่ ไม่จำเป็นจะต้องตั้งค่าใด ๆ
              ให้ท่านเข้าไปที่เว็บไซต์ผ่านทาง GOOGLE และท่านก็สามารถ SEARCH หา
              wmbet.asia เพื่อเข้าเล่นคาสิโน ทุกค่ายได้เลยทั้งสะดวก รวดเร็ว
              และง่ายดายที่สุด
            </li>{" "}
            <li className="nav-item mt-2">
              - การเดิมพันผ่านทางคอมพิวเตอร์ และแท็บเล็ต
              รวมไปถึงเครื่องมืออุปกรณ์อื่น ๆ
              ที่สามารถเชื่อมต่อเข้าทางอินเทอร์เน็ต และ BROWSER
              ได้โดยสามารถเข้าถึงหน้าเว็บไซต์หลักของเราโดยเริ่มจากการเชื่อมต่ออินเทอร์เน็ตแล้วก็เข้าสู่หน้าเว็บหลักของเรา
              แน่นอนว่าสามารถเล่นได้ง่าย และเสถียรมากเพราะมีการตรวจสอบ
              และพัฒนามาเป็นอย่างดี
            </li>{" "}
          </ul>{" "}
        </div>
      </div>
      <div className="-banner-wrapper">
        <img
          alt="Fairbet Image"
          className="img-fluid lazyload -mobile-img"
          width={1000}
          height={590}
          data-src="/build/web/igame-index-lobby-wm/img/wm-hot-game-banner.png?v=4"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        />
      </div>
    </div>
  </div>
  <div className="x-question-and-answer-container">
    <div className="container">
      <h3 className="-title">คำถามที่พบบ่อย Fairbet</h3>
      <div
        className="-accordion-list-wrapper accordion"
        id="questionAndAnswerAccordion"
      >
        <article className="-accordion-list-item-wrapper">
          <h4
            className="-btn "
            data-toggle="collapse"
            data-target="#questionAndAnswerAccordion-wm-casino-popular-game"
            aria-expanded={1}
            aria-controls="questionAndAnswerAccordion-wm-casino-popular-game"
          >
            เกมที่ได้รับความนิยมมากที่สุดใน Fairbet?
            <i className="fas fa-plus" />
            <i className="fas fa-minus" />
          </h4>
          <div
            id="questionAndAnswerAccordion-wm-casino-popular-game"
            className="collapse show js-q-and-a-article-content"
            aria-labelledby="headingOne"
            data-parent="#questionAndAnswerAccordion"
          >
            <p className="-description">
              บาคาร่าเป็นเกมที่ได้รับความนิยมมากที่สุด อย่างไรก็ตาม Fairbet
              มีเกมมากมายที่คุณชื่นชอบให้เลือกสรร
              ตั้งแต่เกมสุดคลาสสิคอย่างรูเล็ตและแบล็คแจ็คไปจนถึงเกมที่ได้รับความนิยมสูงในเอเชียอย่างไฮโลและเสือมังกร
            </p>
          </div>
        </article>
        <article className="-accordion-list-item-wrapper">
          <h4
            className="-btn collapsed"
            data-toggle="collapse"
            data-target="#questionAndAnswerAccordion-wm-casino-commission"
            aria-expanded=""
            aria-controls="questionAndAnswerAccordion-wm-casino-commission"
          >
            Fairbet ให้ค่าคอมมิชชั่นได้เท่าไหร่?
            <i className="fas fa-plus" />
            <i className="fas fa-minus" />
          </h4>
          <div
            id="questionAndAnswerAccordion-wm-casino-commission"
            className="collapse js-q-and-a-article-content"
            aria-labelledby="headingOne"
            data-parent="#questionAndAnswerAccordion"
          >
            <p className="-description">
              wmbet.ai casino ให้คอมมิชชั่นมากกว่าที่ใด เพราะ มอบ 5% ทุกยอดได้
              หรือ ยอดเสีย ทุปสัปดาห์
            </p>
          </div>
        </article>
        <article className="-accordion-list-item-wrapper">
          <h4
            className="-btn collapsed"
            data-toggle="collapse"
            data-target="#questionAndAnswerAccordion-wm-casino-register"
            aria-expanded=""
            aria-controls="questionAndAnswerAccordion-wm-casino-register"
          >
            สมัครสมาชิกกับ Fairbet ได้อย่างไร?
            <i className="fas fa-plus" />
            <i className="fas fa-minus" />
          </h4>
          <div
            id="questionAndAnswerAccordion-wm-casino-register"
            className="collapse js-q-and-a-article-content"
            aria-labelledby="headingOne"
            data-parent="#questionAndAnswerAccordion"
          >
            <div className="-description">
              {" "}
              <p>
                การสมัครสมาชิกกับ Fairbet สามารถทำผ่าน 3 ขั้นตอนง่ายๆ ดังนี้
              </p>{" "}
              <ul className="list-unstyled">
                {" "}
                <li>1. กรอกเบอร์โทรศัพท์มือถือของคุณให้ถูกต้อง</li>{" "}
                <li>
                  2. รอรับ SMS ยืนยัน จากนั้นกรอกรหัส OTP ที่ได้รับให้ถูกต้อง
                  พร้อมตั้งรหัสผ่านเพื่อเข้าเล่นเกม
                </li>{" "}
                <li>
                  3. ใส่หมายเลขบัญชีและชื่อบัญชีให้ถูกต้อง
                  และสามารถเข้าร่วมสนุกกับ Fairbet ได้เลยทันที!
                </li>{" "}
              </ul>{" "}
            </div>
          </div>
        </article>
        <article className="-accordion-list-item-wrapper">
          <h4
            className="-btn collapsed"
            data-toggle="collapse"
            data-target="#questionAndAnswerAccordion-wm-casino-promotion"
            aria-expanded=""
            aria-controls="questionAndAnswerAccordion-wm-casino-promotion"
          >
            มีโปรโมชั่นอะไรบ้างที่ Fairbet นำเสนอ?
            <i className="fas fa-plus" />
            <i className="fas fa-minus" />
          </h4>
          <div
            id="questionAndAnswerAccordion-wm-casino-promotion"
            className="collapse js-q-and-a-article-content"
            aria-labelledby="headingOne"
            data-parent="#questionAndAnswerAccordion"
          >
            <p className="-description">
              Fairbet มีโปรโมชั่นหลากหลายให้เลือก โปรดี โปรแรง
              สามารถศึกษาโปรโมชั่นเพิ่มเติมได้ ที่ฝ่ายบริการของเรา
            </p>
          </div>
        </article>
      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default App;
